import { inject, observer } from "mobx-react";
import { Modal, Button } from "antd";
import * as React from "react";

import PageStore from "app/PageStore";

interface AlertProps {
  pageStore?: PageStore;
}

@inject("pageStore")
@observer
class Alert extends React.Component<AlertProps> {
  public render() {
    const { alert, rootContainer } = this.props.pageStore!;
    return (
      <Modal
        title={alert.title}
        visible
        mask
        footer={this.renderFooter()}
        onCancel={this.handleOnCancel}
        getContainer={rootContainer}
      >
        {alert.message &&
          alert.message
            .toString()
            .split("\n")
            .map((x) => <p key={x}>{x}</p>)}
      </Modal>
    );
  }

  private renderFooter = () => {
    const { alert } = this.props.pageStore!;
    const buttons = [];
    if (alert.onCancel) {
      buttons.push(
        <Button key="modal-cancel-button" onClick={this.handleOnCancel}>
          {alert.cancelMessage || "Dismiss"}
        </Button>,
      );
    }

    if (alert.isNegative) {
      buttons.push(
        <Button key="modal-confirm-button" onClick={this.handleOnConfirm}>
          {alert.confirmMessage || "Confirm"}
        </Button>,
      );
    }

    if (alert.onCustom) {
      buttons.push(
        <Button key="modal-custom-button" onClick={this.handleOnCustom}>
          {alert.customMessage}
        </Button>,
      );
    }

    buttons.push(
      <Button
        key="modal-confirm-button"
        type="primary"
        onClick={this.handleOnConfirm}
        autoFocus
      >
        {alert.confirmMessage || "Confirm"}
      </Button>,
    );

    return buttons;
  };

  private handleOnCustom = () => {
    this.props.pageStore!.closeAlert();
    if (this.props.pageStore!.alert.onCustom) {
      this.props.pageStore?.alert.onCustom!();
    }
  };

  private handleOnCancel = () => {
    this.props.pageStore!.closeAlert();
    if (this.props.pageStore!.alert.onCancel) {
      this.props.pageStore?.alert.onCancel!();
    }
  };

  private handleOnConfirm = () => {
    this.props.pageStore!.closeAlert();
    if (this.props.pageStore!.alert.onConfirm) {
      this.props.pageStore?.alert.onConfirm!();
    }
  };
}

export default Alert;
